import * as React from "react";
const HistogramIcon = (props: any) => (
<svg
    width="100px"
    height="100px"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      width={48}
      height={48}
      fill="white"
      fillOpacity={0.01}
      d="M0 0h6v6H0V0z"
    />
    <path
      d="M0.75 0.75v4.5h4.5"
      stroke="#00000050"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 3.75v0.5"
      stroke="#00000050"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.75 2.75v1.5"
      stroke="#00000050"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 0.75v3.5"
      stroke="#00000050"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 1.75v2.5"
      stroke="#00000050"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default HistogramIcon;
